import { Bell, BookOpen, Calendar, ChartNoAxesColumn, List } from 'lucide-react';
import type { LucideIcon } from 'lucide-react';
import { useLocation, useNavigate } from 'react-router';
import { ROUTE } from '../../features/navigation/index.js';
import styles from './bottom-nav.module.css';

type Tab = {
  route: string;
  label: string;
  icon: LucideIcon;
};

const ICON_SIZE = 24;

const TABS: Tab[] = [
  { route: ROUTE.attention, label: 'Клопоти', icon: Bell },
  { route: ROUTE.summary, label: 'Витрати', icon: ChartNoAxesColumn },
  { route: ROUTE.payments, label: 'Підписки', icon: List },
  { route: ROUTE.calendar, label: 'Календар', icon: Calendar },
  { route: ROUTE.references, label: 'Довідники', icon: BookOpen },
];

type TabButtonProps = {
  tab: Tab;
  isActive: boolean;
  onSelect: (route: string) => void;
};

const TabButton = ({ tab, isActive, onSelect }: TabButtonProps) => (
  <button
    type="button"
    className={`${styles.tab} ${isActive ? styles.active : ''}`}
    aria-current={isActive ? 'page' : undefined}
    onClick={() => {
      onSelect(tab.route);
    }}
  >
    <tab.icon className={styles.icon} size={ICON_SIZE} />
    <span className={styles.label}>{tab.label}</span>
  </button>
);

/**
 * The bar under the four top-level screens. Switching a tab replaces the history entry rather
 * than pushing one, so the memory router never grows a trail of tab hops and "back" from a detail
 * screen lands on whichever tab it was opened from.
 */
export const BottomNav = () => {
  const navigate = useNavigate();
  const { pathname } = useLocation();

  const switchTo = (route: string): void => {
    if (route !== pathname) {
      void navigate(route, { replace: true });
    }
  };

  return (
    <nav className={styles.nav} aria-label="Розділи">
      {TABS.map((tab) => (
        <TabButton
          key={tab.route}
          tab={tab}
          isActive={pathname === tab.route}
          onSelect={switchTo}
        />
      ))}
    </nav>
  );
};
